import type { Currency } from '@recruitee/pricing-types';
import type { BillingPlan, BillingPlanTier, CustomBillingPlan } from '@recruitee/products-types';
import type { CompanyVerificationRequestStatus } from '@recruitee/spam-verification-data';
import type { Addon, PaymentInterval, SubscriptionStatus } from '@recruitee/subscription-types';

import type { SlotLimitExceeded } from '../../helpers/calculate-slots-limit';

export interface PlanPickerProduct {
  codename: BillingPlanTier;
  status: ProductStatus;
  state: PlanPickerProductState;
  limits: SlotLimitExceeded;
  product?: BillingPlan;
}

export enum ProductStatus {
  Unavailable,
  ManualService,
  ManualServiceOwned,
  Owned,
  TierOwned,
  SelfServiceDowngrade,
  SelfService,
  SelfServiceUpgrade,
}

export interface PlanPickerProductState {
  ownedSlots: number;
  isActive: boolean;
  costPerMonth: number;
  costPerMonthWithoutDiscount?: number;
  selectedSlots: number;
  showCta: boolean;
  showPrice: boolean;
  showSlotPicker: boolean;
  showCustomBadge: boolean;
  showSlotLimitMessage: boolean;
  showChurn: boolean;
  disableCta: boolean;
}

export interface PlanPickerState {
  highlighted: BillingPlanTier;
  assignedProduct?: CustomBillingPlan;
  assignedProductSlots?: number;
  assignedProductLimitExceeded?: boolean;
  interval: PaymentInterval;
  currency: Currency;
  isSelfService: boolean;
  isTrial: boolean;
  isExternalBilling: boolean;
  ownedSlots: number;
  showCurrencyControl: boolean;
  showIntervalControl: boolean;
  activeProduct: BillingPlan;
  products: PlanPickerProduct[];
  tier: BillingPlanTier;
}

export interface PlanPickerStateFactoryData {
  ownedSlots: number;
  interval: PaymentInterval;
  intervalDirty: boolean;
  currency: Currency;
  currencyLock: boolean;
  isSelfService: boolean;
  isSubscriptionBlocked: boolean;
  isSubscriptionActive: boolean;
  isTrial: boolean;
  isExternalBilling: boolean;
  activeProduct: BillingPlan;
  billingPlans: BillingPlan[];
  hasAnySubscription: boolean;
  slotsTotal: number;
  jobSlotsUsed: number;
  assignedProduct: CustomBillingPlan | undefined;
  subscriptionStatus: SubscriptionStatus | null;
  tier: BillingPlanTier;
  spamVerificationStatus: CompanyVerificationRequestStatus;
  addons: Addon[];
}

export type RecognizedProductCode =
  | BillingPlanTier.Launch
  | BillingPlanTier.Scale
  | BillingPlanTier.Lead;
export type CustomizedSlots = Record<string, number | undefined>;
